/* ============================================================
   CBoysTV FAQ — faq.js
   Upload to: Shopify Admin → Assets
   ============================================================ */

(function () {
  'use strict';

  const searchInput  = document.getElementById('faq-search');
  const searchClear  = document.getElementById('faq-search-clear');
  const noResults    = document.getElementById('faq-no-results');
  const catButtons   = document.querySelectorAll('.faq-cat-btn');
  const allSections  = document.querySelectorAll('.faq-section');
  const allItems     = document.querySelectorAll('.faq-item');

  if (!searchInput) return; // Guard: only run on FAQ pages

  /* ---- Category filter ---- */
  catButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      catButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Clear search when switching categories
      searchInput.value = '';
      searchClear.hidden = true;
      clearHighlights();

      const cat = btn.dataset.cat;
      filterByCategory(cat);
    });
  });

  function filterByCategory(cat) {
    let visibleCount = 0;

    allSections.forEach(section => {
      if (cat === 'all' || section.dataset.cat === cat) {
        section.hidden = false;
      } else {
        section.hidden = true;
      }
    });

    allItems.forEach(item => {
      item.hidden = false;
      visibleCount++;
    });

    noResults.hidden = visibleCount > 0;
  }

  /* ---- Search ---- */
  searchInput.addEventListener('input', () => {
    const query = searchInput.value.trim();
    searchClear.hidden = query === '';

    if (query === '') {
      // Reset to active category
      const activeCat = document.querySelector('.faq-cat-btn.active');
      clearHighlights();
      filterByCategory(activeCat ? activeCat.dataset.cat : 'all');
      return;
    }

    // When searching, show all categories
    catButtons.forEach(b => b.classList.remove('active'));
    document.querySelector('[data-cat="all"]')?.classList.add('active');

    runSearch(query);
  });

  searchClear.addEventListener('click', () => {
    searchInput.value = '';
    searchClear.hidden = true;
    clearHighlights();
    filterByCategory('all');
    searchInput.focus();
  });

  function runSearch(rawQuery) {
    const query = rawQuery.toLowerCase();
    let visibleCount = 0;

    clearHighlights();

    allSections.forEach(section => { section.hidden = false; });

    allItems.forEach(item => {
      const summaryEl = item.querySelector('.faq-question');
      const answerEl  = item.querySelector('.faq-answer');

      const summaryText = summaryEl ? summaryEl.textContent.toLowerCase() : '';
      const answerText  = answerEl  ? answerEl.textContent.toLowerCase()  : '';

      if (summaryText.includes(query) || answerText.includes(query)) {
        item.hidden = false;
        visibleCount++;

        // Highlight matches in question text
        if (summaryEl) highlightText(summaryEl, rawQuery);

        // Open item if match is in answer
        if (answerText.includes(query) && !item.open) {
          item.open = true;
        }
      } else {
        item.hidden = true;
      }
    });

    // Hide sections that have no visible children
    allSections.forEach(section => {
      const visibleItems = section.querySelectorAll('.faq-item:not([hidden])');
      section.hidden = visibleItems.length === 0;
    });

    noResults.hidden = visibleCount > 0;
  }

  /* ---- Text highlighting ---- */
  function highlightText(el, query) {
    // Only highlight in the direct text node of the summary (not the ::after chevron)
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }

    textNodes.forEach(textNode => {
      const text = textNode.textContent;
      const lowerText = text.toLowerCase();
      const lowerQuery = query.toLowerCase();
      const idx = lowerText.indexOf(lowerQuery);

      if (idx === -1) return;

      const before = text.slice(0, idx);
      const match  = text.slice(idx, idx + query.length);
      const after  = text.slice(idx + query.length);

      const fragment = document.createDocumentFragment();
      if (before) fragment.appendChild(document.createTextNode(before));

      const mark = document.createElement('mark');
      mark.className = 'faq-highlight';
      mark.textContent = match;
      fragment.appendChild(mark);

      if (after) fragment.appendChild(document.createTextNode(after));

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function clearHighlights() {
    document.querySelectorAll('.faq-highlight').forEach(mark => {
      const parent = mark.parentNode;
      parent.replaceChild(document.createTextNode(mark.textContent), mark);
      parent.normalize();
    });
  }

  /* ---- URL hash: deep-link to a category ---- */
  // e.g. /pages/faq#returns will auto-select that tab
  function applyHashFilter() {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;
    const matchBtn = document.querySelector(`.faq-cat-btn[data-cat="${hash}"]`);
    if (matchBtn) {
      matchBtn.click();
      matchBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  applyHashFilter();
  window.addEventListener('hashchange', applyHashFilter);

})();
